export class ProductAnalysisModel{
    rmProcurementWeight : number
    rmReceivedWeight : number
    purchaseDiffrence: number
    honProduction: number
    netHonForOtherProduction: number
    honToHlsoWeight: number
    honToHlsoYield : number
    totalSlabs : number
    totalNetWeight: number
    totalGrossWeight: number
    totalHeadOnWeight: number
    totalProduction : number
    diffrenceInProdcutionWeight : number
    yieldVariation : number
    netYield : number
    grossYield :number
    iqfProductsInfo : MISProductsInfo[]
    blockProductsInfo : MISProductsInfo[]

    constructor(rmProcurementWeight : number,rmReceivedWeight : number,purchaseDiffrence: number,honProduction: number,netHonForOtherProduction: number,honToHlsoWeight: number,honToHlsoYield : number,totalSlabs : number,totalNetWeight: number,totalGrossWeight: number,totalHeadOnWeight: number,totalProduction : number,diffrenceInProdcutionWeight : number,yieldVariation : number,netYield : number,grossYield :number,iqfProductsInfo : MISProductsInfo[],blockProductsInfo : MISProductsInfo[]){
    this.rmProcurementWeight  = rmProcurementWeight 
    this.rmReceivedWeight  = rmReceivedWeight 
    this.purchaseDiffrence = purchaseDiffrence
    this.honProduction = honProduction
    this.netHonForOtherProduction = netHonForOtherProduction
    this.honToHlsoWeight = honToHlsoWeight
    this.honToHlsoYield  = honToHlsoYield 
    this.totalSlabs  = totalSlabs 
    this.totalNetWeight = totalNetWeight
    this.totalGrossWeight = totalGrossWeight
    this.totalHeadOnWeight = totalHeadOnWeight
    this.totalProduction  = totalProduction 
    this.diffrenceInProdcutionWeight  = diffrenceInProdcutionWeight 
    this.yieldVariation  = yieldVariation 
    this.netYield  = netYield 
    this.grossYield  = grossYield 
    this.iqfProductsInfo  = iqfProductsInfo 
    this.blockProductsInfo  = blockProductsInfo 
    }
}

export class MISProductsInfo{
    productType:string
    noOfSlabs: number
    weightPerSlab:number
    netTotalWeight: number
    grossTotalWeight: number
    yieldPer:number
    totalEquivalentHeadOnWeight: number
    produciton :number

    constructor(productType:string,noOfSlabs: number,weightPerSlab:number,netTotalWeight: number,grossTotalWeight: number,yieldPer:number,totalEquivalentHeadOnWeight: number,produciton :number){
    this.productType = productType
    this.noOfSlabs = noOfSlabs
    this.weightPerSlab = weightPerSlab
    this.netTotalWeight = netTotalWeight
    this.grossTotalWeight = grossTotalWeight
    this.yieldPer = yieldPer
    this.totalEquivalentHeadOnWeight = totalEquivalentHeadOnWeight
    this.produciton  = produciton 
    }

}